import { useMutation } from "@tanstack/react-query";
import { StripeService } from "../../services/stripe.service";
import {
  IAttachPaymentMethod,
  IBuyAddonModel,
  IBuySubscriptionModel,
  ICancelSubscriptionModel,
  IChangeSubscriptionModel,
  IStripePaymentResponse,
} from "../../models/Stripe";

export const useStripeMutations = () => {
  const { mutate: attach } = useMutation<{}, Error, IAttachPaymentMethod>({
    mutationFn: (model) => {
      return StripeService.attachPaymentMethod(model).then((res) => res.data);
    },
  });

  const { mutate: setAsDefault } = useMutation<{}, Error, string>({
    mutationFn: (id) => {
      return StripeService.setAsDefaultPaymentMethod(id).then((res) => res.data);
    },
  });

  const { mutate: detach } = useMutation<{}, Error, string>({
    mutationFn: (id) => {
      return StripeService.detachPaymentMethod(id).then((res) => res.data);
    },
  });

  const { mutate: buyAddon } = useMutation<IStripePaymentResponse, Error, IBuyAddonModel>({
    mutationFn: (model) => {
      return StripeService.buyAddon(model).then((res) => res.data);
    },
  });

  const { mutate: changeSubscription } = useMutation<
    IStripePaymentResponse,
    Error,
    IChangeSubscriptionModel
  >({
    mutationFn: (model) => {
      return StripeService.changeSubscription(model).then((res) => res.data);
    },
  });

  const { mutate: buySubscription } = useMutation<
    IStripePaymentResponse,
    Error,
    IBuySubscriptionModel
  >({
    mutationFn: (model) => {
      return StripeService.buySubscription(model).then((res) => res.data);
    },
  });

  const { mutate: cancelSubscription } = useMutation<
    {},
    Error,
    { id: string; model: ICancelSubscriptionModel }
  >({
    mutationFn: ({ id, model }) => {
      return StripeService.cancelSubscription(id, model).then((res) => res.data);
    },
  });

  const { mutate: resumeSubscriptionCancellation } = useMutation<{}, Error, string>({
    mutationFn: (userSubscriptionId) => {
      return StripeService.resumeSubscriptionCancellation(userSubscriptionId).then(
        (res) => res.data
      );
    },
  });

  return {
    attach,
    setAsDefault,
    detach,
    buyAddon,
    changeSubscription,
    buySubscription,
    cancelSubscription,
    resumeSubscriptionCancellation,
  };
};
